// extracted by mini-css-extract-plugin
export default {"mainImgStyle":"imgcomp_mainImgStyle__LTqeb","figure":"imgcomp_figure__OrSaU","gallery":"imgcomp_gallery__HpV32","noImgToDisplay":"imgcomp_noImgToDisplay__FxUYm"};